import { useState, useEffect, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { getResponseById, deleteResponse } from 'api/responses';

import Modal from 'components/modal/delete';
import NoAccess from 'pages/no_access';

import Loading from 'components/loading/loading';
import Deleted from 'components/deleted/deleted';

const ResponseItem = () => {
  const [loading, setLoading] = useState(true);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [data, setData] = useState(null);
  const [deletedByData, setDeletedByData] = useState(null);
  const { id } = useParams();
  const history = useHistory();

  const fetchResponse = useCallback(async () => {
    setLoading(true);
    const response = await getResponseById(id);
    if (response.deletedAt && response.deletedBy) {
      setDeletedByData({
        email: data.deletedBy.email,
        deletedAt: response.deletedAt,
      });
    } else {
      setData(response);
    }

    setLoading(false);
  }, [id]);

  const onDelete = async () => {
    setLoading(true);
    await deleteResponse(id);

    history.goBack();
    setLoading(false);
  };

  useEffect(() => {
    fetchResponse();
  }, [fetchResponse]);

  if (loading) return <Loading />;
  if (data?.statusCode === 403) return <NoAccess />;
  if (deletedByData) return <Deleted deletedBy={deletedByData} />;

  return (
    <>
      <main className="th-main">
        <section className="th-canvas">
          <div className="flex justify-between items-center mb10 bt b--lightgrey-d1 pt8">
            <div>
              <h2 className="th-canvas-title" data-test-screen-title>
                <span>{data.name}</span>
              </h2>
            </div>
            <section className="view-actions">
              <button
                className="btn-red mr5"
                data-cy="delete"
                onClick={() => setDeleteModalOpen(true)}
              >
                <span>Delete</span>
              </button>
              <button
                className="btn-green"
                data-cy="edit"
                onClick={() => history.push(`/responses/${data.id}/edit`)}
              >
                <span>Edit</span>
              </button>
            </section>
          </div>
          <div className="w-100 flex flex-column items-start justify-between">
            {data.fields.filter(Boolean).map((f, index) => (
              <div className="w-100" key={index}>
                <span className="apps-grid-title">{f.label || f.question}</span>
                <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
                  {f.value || f.answer}
                </p>
              </div>
            ))}
          </div>
        </section>
      </main>
      {deleteModalOpen && (
        <Modal
          title="Response delete"
          content={`Are you sure you want to delete the <b>Response</b> of <b>${
            data.customer &&
            data.customer.firstName + ' ' + data.customer.lastName
          }</b>?`}
          onClose={() => setDeleteModalOpen(false)}
          onDelete={() => onDelete()}
        />
      )}
    </>
  );
};

export default ResponseItem;
